export default __webpack_public_path__ + "static/media/maneuverelusivedaring.48556020.png";